module.exports = __webpack_public_path__ + "images/emoji/love_hotel.fc9160f34b981bcd762e.png";